import Typography from '@components/std-components/Typography'
import React, { FC, memo } from 'react'
import * as css from './QtyCellValueText.css'
import cn from 'classnames'

export interface QtyCellValueTextProps {
  value: number | string
  isInactive?: boolean
  disabled?: boolean
}

const QtyCellValueText: FC<QtyCellValueTextProps> = memo(props => {
  const { value, isInactive = false, disabled } = props
  return (
    <Typography
      variant='section3'
      color='primary'
      classes={cn({ [css['inactive']]: isInactive, [css['input-disabled']]: disabled })}
    >
      {value}
    </Typography>
  )
})

export default QtyCellValueText
